import styled from 'styled-components';

export const MessageText = styled.span`
    align-self: stretch;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;
`;
